import { TipoTaglia } from './TipoTaglia';

export interface ProgressoSpedizione {
    indice: number;
    stato: string;
    idLavorazione: string;
    idSpedizione: string;
    ordineNumero: string;
    ordineLinea: string;
    dataCreazione?: Date;
    tipoTaglie: TipoTaglia;
    qtaTaglia01: number;
    qtaTaglia02: number;
    qtaTaglia03: number;
    qtaTaglia04: number;
    qtaTaglia05: number;
    qtaTaglia06: number;
    qtaTaglia07: number;
    qtaTaglia08: number;
    qtaTaglia09: number;
    qtaTaglia10: number;
    qtaTaglia11: number;
    qtaTaglia12: number;
    qtaTaglia13: number;
    qtaTaglia14: number;
    qtaTaglia15: number;
    qtaTaglia16: number;
    dataElaborazione?: Date;
    ddtResoData?: Date;
}

export class ProxyProgressoSpedizione {
    progressoSpedizione!: ProgressoSpedizione;
    qtaTaglie: number[] = [];
    qtaTaglieStatoIniziale: number[] = [];
    tipoTaglie: string[] = [];

    constructor(proSped: ProgressoSpedizione) {
        this.progressoSpedizione = proSped;

        this.qtaTaglie[0] = proSped.qtaTaglia01;
        this.qtaTaglie[1] = proSped.qtaTaglia02;
        this.qtaTaglie[2] = proSped.qtaTaglia03;
        this.qtaTaglie[3] = proSped.qtaTaglia04;
        this.qtaTaglie[4] = proSped.qtaTaglia05;
        this.qtaTaglie[5] = proSped.qtaTaglia06;
        this.qtaTaglie[6] = proSped.qtaTaglia07;
        this.qtaTaglie[7] = proSped.qtaTaglia08;
        this.qtaTaglie[8] = proSped.qtaTaglia09;
        this.qtaTaglie[9] = proSped.qtaTaglia10;
        this.qtaTaglie[10] = proSped.qtaTaglia11;
        this.qtaTaglie[11] = proSped.qtaTaglia12;
        this.qtaTaglie[12] = proSped.qtaTaglia13;
        this.qtaTaglie[13] = proSped.qtaTaglia14;
        this.qtaTaglie[14] = proSped.qtaTaglia15;
        this.qtaTaglie[15] = proSped.qtaTaglia16;

        this.qtaTaglieStatoIniziale = Array.from(this.qtaTaglie);

        this.tipoTaglie[0] = proSped.tipoTaglie.taglia01;
        this.tipoTaglie[1] = proSped.tipoTaglie.taglia02;
        this.tipoTaglie[2] = proSped.tipoTaglie.taglia03;
        this.tipoTaglie[3] = proSped.tipoTaglie.taglia04;
        this.tipoTaglie[4] = proSped.tipoTaglie.taglia05;
        this.tipoTaglie[5] = proSped.tipoTaglie.taglia06;
        this.tipoTaglie[6] = proSped.tipoTaglie.taglia07;
        this.tipoTaglie[7] = proSped.tipoTaglie.taglia08;
        this.tipoTaglie[8] = proSped.tipoTaglie.taglia09;
        this.tipoTaglie[9] = proSped.tipoTaglie.taglia10;
        this.tipoTaglie[10] = proSped.tipoTaglie.taglia11;
        this.tipoTaglie[11] = proSped.tipoTaglie.taglia12;
        this.tipoTaglie[12] = proSped.tipoTaglie.taglia13;
        this.tipoTaglie[13] = proSped.tipoTaglie.taglia14;
        this.tipoTaglie[14] = proSped.tipoTaglie.taglia15;
        this.tipoTaglie[15] = proSped.tipoTaglie.taglia16;
    }

    toProgressoSpedizione(): ProgressoSpedizione {
        this.progressoSpedizione.qtaTaglia01 = this.qtaTaglie[0];
        this.progressoSpedizione.qtaTaglia02 = this.qtaTaglie[1];
        this.progressoSpedizione.qtaTaglia03 = this.qtaTaglie[2];
        this.progressoSpedizione.qtaTaglia04 = this.qtaTaglie[3];
        this.progressoSpedizione.qtaTaglia05 = this.qtaTaglie[4];
        this.progressoSpedizione.qtaTaglia06 = this.qtaTaglie[5];
        this.progressoSpedizione.qtaTaglia07 = this.qtaTaglie[6];
        this.progressoSpedizione.qtaTaglia08 = this.qtaTaglie[7];
        this.progressoSpedizione.qtaTaglia09 = this.qtaTaglie[8];
        this.progressoSpedizione.qtaTaglia10 = this.qtaTaglie[9];
        this.progressoSpedizione.qtaTaglia11 = this.qtaTaglie[10];
        this.progressoSpedizione.qtaTaglia12 = this.qtaTaglie[11];
        this.progressoSpedizione.qtaTaglia13 = this.qtaTaglie[12];
        this.progressoSpedizione.qtaTaglia14 = this.qtaTaglie[13];
        this.progressoSpedizione.qtaTaglia15 = this.qtaTaglie[14];
        this.progressoSpedizione.qtaTaglia16 = this.qtaTaglie[15];

        return this.progressoSpedizione;
    }
}